import { defineRule } from 'vee-validate';

// For HTML fields (can't initialise before window.tinyMCE exists)
defineRule('html_required', (value, { editorId }) => {
  const html = (window.tinyMCE?.get(editorId)?.getContent() || value || '');
  return (new DOMParser()
           .parseFromString(html, 'text/html')
           .body.textContent
           .replace(/[\s\u00A0]/g, '')
           .length > 0)
         ? true
         : 'This field is required';
});

export const TinyMceBaseConfig = {
  height: 200,
  menubar: false,
  plugins: ['charmap paste'],
  toolbar: 'bold italic | subscript superscript | removeformat | charmap',
  forced_root_block: false,
  deprecation_warnings: false,
  statusbar: false,
  resize: false,
  valid_elements: 'b/strong,i/em,sub,sup',
  //nit_instance_callback: (editor) => editor.setMode(editor.settings.isFormLocked ? 'readonly' : 'design'),
  content_style: '.mce-content-readonly { color: #7a7a7a; }',
};

export default {
  data() {
    return {
      TinyMceConfig: { ...TinyMceBaseConfig },
    };
  },
};